import { useTable } from 'react-table'

import { Paginate } from '..'

import * as S from './styles'

type TableProps = {
  columns: any
  dataTable: any
  onClick?: any
  handlePageClick?: any
  pageCount?: any
  className?: string
  hasPagination?: boolean
}

const Table = ({
  columns,
  dataTable,
  onClick,
  handlePageClick,
  pageCount,
  className,
  hasPagination = true
}: TableProps) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data: dataTable
    })

  return (
    <S.Wrapper className={className}>
      <table {...getTableProps()}>
        <thead>
          {headerGroups?.map((headerGroup) => (
            <tr {...headerGroup?.getHeaderGroupProps()}>
              {headerGroup?.headers?.map((column: any) => (
                <th
                  {...column?.getHeaderProps({
                    style: { ...column.style }
                  })}
                >
                  {column?.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows?.map((row) => {
            prepareRow(row)
            return (
              <tr {...row?.getRowProps()}>
                {row?.cells?.map((cell) => {
                  return (
                    <td
                      {...cell?.getCellProps()}
                      onClick={() =>
                        typeof cell?.value !== 'object' && onClick(row)
                      }
                    >
                      {cell?.render('Cell')}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {hasPagination && (
        <Paginate handlePageClick={handlePageClick} pageCount={pageCount} />
      )}
    </S.Wrapper>
  )
}

export default Table
